import { AppRoute } from '@app/core/routing/AppRoute';
import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { DailymotionApiKeyConnectPage } from '@app/modules/social-export/platforms/dailymotion/connect/DailymotionApiKeyConnectPage';
import { PlatformSettingsPage } from '@app/modules/social-export/screens/manage/platforms/PlatformSettingsPage';
import { SocialExportManagePage } from '@app/modules/social-export/screens/manage/SocialExportManagePage';
import { SocialExportUploadedPage } from '@app/modules/social-export/screens/uploaded/SocialExportUploadedPage';
import { Switch, useRouteMatch } from 'react-router-dom';

export function AdminSocialExportRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <AppRoute path={`${path}/uploaded/:platform`} component={SocialExportUploadedPage} />
      <AppRoute
        path={`${path}/dailymotion/connect/:station`}
        component={DailymotionApiKeyConnectPage}
      />
      <AppRoute path={`${path}/:platform/settings/:station`} component={PlatformSettingsPage} />
      {socialPlatforms.all().map((platform) => (
        <AppRoute
          key={platform.id}
          path={`${path}/${platform.id.toLowerCase()}`}
          component={() => <SocialExportManagePage platform={platform} />}
        />
      ))}
    </Switch>
  );
}
